// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TradingOrderStatus;
(function (TradingOrderStatus) {
    TradingOrderStatus[TradingOrderStatus["None"] = 0] = "None";
    TradingOrderStatus[TradingOrderStatus["Placing"] = 1] = "Placing";
    TradingOrderStatus[TradingOrderStatus["Error"] = 2] = "Error";
    TradingOrderStatus[TradingOrderStatus["CancelledByUser"] = 3] = "CancelledByUser";
    TradingOrderStatus[TradingOrderStatus["IllegalParameters"] = 4] = "IllegalParameters";
    TradingOrderStatus[TradingOrderStatus["Opened"] = 5] = "Opened";
    TradingOrderStatus[TradingOrderStatus["Filled"] = 6] = "Filled";
})(TradingOrderStatus || (TradingOrderStatus = {}));
